import React from 'react'
import DamageWaiver from './DamageWaiver'
import ProtectionWaiver from './ProtectionWaiver'

function Waivers() {
  return (
    <>
      <ProtectionWaiver />
      <DamageWaiver />
    </>
  )
}

export default Waivers
